import React, { Component } from "react"
import styled from "styled-components"
import logo from "../images/logo.svg"
import { Link } from "gatsby"

const HeaderGroup = styled.header`
  position: fixed;
  padding: 20px 100px;
  z-index: 100;
  width: 100%;
  transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);

  background: ${(props) => (props.hasScrolled ? "rgba(0, 0, 0, 0.6)" : "")};
  backdrop-filter: ${(props) => (props.hasScrolled ? "blur(20px)" : "none")};
  a {
    color: ${(props) => (props.hasScrolled ? "#f7f7f7" : "#252323")};
  }
`

const LogoGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const Logo = styled.img`
  padding-right: 20px;
`

const Heading = styled.h4`
  font-weight: 700;
  font-size: 1.8rem;
`

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasScrolled: false,
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  handleScroll = (event) => {
    const scrollTop = window.pageYOffset

    if (scrollTop > 50) {
      this.setState({ hasScrolled: true })
    } else {
      this.setState({ hasScrolled: false })
    }
  }

  render() {
    return (
      <HeaderGroup hasScrolled={this.state.hasScrolled ? "hasScrolled" : ""}>
        <Link to="/">
          <LogoGroup>
            <Logo src={logo} alt="Appointix Logo" />
            <Heading>Appointix</Heading>
          </LogoGroup>
        </Link>
      </HeaderGroup>
    )
  }
}

export default Header
